export const actionTypes = {
  GET_BANNERS_LIST_PENDING: "GET_BANNERS_LIST_PENDING",
  GET_BANNERS_LIST_SUCCESS: "GET_BANNERS_LIST_SUCCESS",
  GET_BANNERS_LIST_ERROR: "GET_BANNERS_LIST_ERROR",

  GET_BANNERS_BY_ID_PENDING: "GET_BANNERS_BY_ID_PENDING",
  GET_BANNERS_BY_ID_SUCCESS: "GET_BANNERS_BY_ID_SUCCESS",
  GET_BANNERS_BY_ID_ERROR: "GET_BANNERS_BY_ID_ERROR",

  ADD_BANNER_PENDING: "ADD_BANNER_PENDING",
  ADD_BANNER_SUCCESS: "ADD_BANNER_SUCCESS",
  ADD_BANNER_ERROR: "ADD_BANNER_ERROR",

  UPDATE_BANNER_PENDING: "UPDATE_BANNER_PENDING",
  UPDATE_BANNER_SUCCESS: "UPDATE_BANNER_SUCCESS",
  UPDATE_BANNER_ERROR: "UPDATE_BANNER_ERROR",

  DELETE_BANNER_PENDING: "DELETE_BANNER_PENDING",
  DELETE_BANNER_SUCCESS: "DELETE_BANNER_SUCCESS",
  DELETE_BANNER_ERROR: "DELETE_BANNER_ERROR",

  SET_SEARCH_FILTERS: "SET_SEARCH_FILTERS",

  SET_ROW_REORDER: "SET_ROW_REORDER",

  SET_SHOW_ROW_REORDER_MODAL: "SET_SHOW_ROW_REORDER_MODAL",

  SET_BANNER_SCREEN_FILTER: "SET_BANNER_SCREEN_FILTER",
  RESET_BANNER_SCREEN_FILTER: "RESET_BANNER_SCREEN_FILTER",

  SET_BANNER_BACKGROUND_COLOR: "SET_BANNER_BACKGROUND_COLOR",
  RESET_BANNER_BACKGROUND_COLOR: "RESET_BANNER_BACKGROUND_COLOR",
};

const initialState = {
  getBannersListPending: false,
  getBannersListSuccess: false,
  getBannersListError: null,

  getBannersByIdPending: false,
  getBannersByIdSuccess: false,
  getBannersByIdError: null,

  addBannerPending: false,
  addBannerSuccess: false,
  addBannerError: null,

  updateBannerPending: false,
  updateBannerSuccess: false,
  updateBannerError: null,

  deleteBannerPending: false,
  deleteBannerSuccess: false,
  deleteBannerError: null,

  bannersList: [],
  bannerById: null,
  //
  titleSearch: "",
  bannerScreenFilter: "",
  //
  rowReordered: false,
  showRowReorderedModal: false,
  //
  redirectLink: "",
  //
  bgColor: "",
};

export default function bannerManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_BANNERS_LIST_PENDING:
    case actionTypes.GET_BANNERS_LIST_SUCCESS:
    case actionTypes.GET_BANNERS_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_BANNERS_BY_ID_PENDING:
    case actionTypes.GET_BANNERS_BY_ID_SUCCESS:
    case actionTypes.GET_BANNERS_BY_ID_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_BANNER_PENDING:
    case actionTypes.ADD_BANNER_SUCCESS:
    case actionTypes.ADD_BANNER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_BANNER_PENDING:
    case actionTypes.UPDATE_BANNER_SUCCESS:
    case actionTypes.UPDATE_BANNER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.DELETE_BANNER_PENDING:
    case actionTypes.DELETE_BANNER_SUCCESS:
    case actionTypes.DELETE_BANNER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.SET_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    case actionTypes.SET_ROW_REORDER:
      return Object.assign({}, state, payload);

    case actionTypes.SET_SHOW_ROW_REORDER_MODAL:
      return Object.assign({}, state, payload);

    case actionTypes.SET_BANNER_SCREEN_FILTER:
    case actionTypes.RESET_BANNER_SCREEN_FILTER:
      return Object.assign({}, state, payload);

    case actionTypes.SET_BANNER_BACKGROUND_COLOR:
    case actionTypes.RESET_BANNER_BACKGROUND_COLOR:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
